
import { motion } from 'framer-motion';

const steps = [
  {
    number: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話でご連絡ください。担当者が24時間以内にご返信いたします。',
    icon: 'ri-mail-send-line',
  },
  {
    number: '02',
    title: 'ヒアリング・提案',
    description: 'ご予算・目的・ターゲットをお伺いし、最適なロケーションとプランをご提案します。',
    icon: 'ri-presentation-line',
  },
  {
    number: '03',
    title: 'クリエイティブ制作',
    description: '専門チームがビルボード用のクリエイティブを制作。既存素材の最適化も対応可能です。',
    icon: 'ri-palette-line',
  },
  {
    number: '04',
    title: '掲載開始',
    description: '審査完了後、指定日時から広告掲載を開始。リアルタイムで掲載状況をご確認いただけます。',
    icon: 'ri-play-circle-line',
  },
];

export default function AdvertiseProcess() {
  return (
    <section 
      className="py-12 px-6 relative"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/db3aa514b93a3f281636e4ae5924ebff.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-white/85 backdrop-blur-sm"></div>
      <div className="max-w-[1400px] mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <span className="text-electric-blue font-medium text-xs uppercase tracking-wider">
            Process
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-2">
            ビルボード広告掲載の流れ
          </h2>
          <p className="text-gray-600 text-sm max-w-2xl mx-auto">
            お問い合わせから屋外広告掲載開始まで、専任担当者がサポートいたします
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative"
            >
              <div className="bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-shadow h-full">
                <div className="w-10 h-10 bg-gradient-to-br from-electric-blue to-cyan-400 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${step.icon} text-lg text-white`}></i>
                </div>
                <span className="text-3xl font-black text-gray-100 absolute top-4 right-4">
                  {step.number}
                </span>
                <h3 className="text-base font-bold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-2 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-lg text-gray-400"></i>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
